export class AnswerImageDiscription {
  id: number = null
  page: number = null
  x: number = null
  y: number = null
  discription_text: string = ""
  link_url: string = ""
  is_show_popover: boolean = false

  constructor(x: any){
    if(x == null){
      return;
    }

    this.id = x.id;
    this.page = x.page;
    this.x = x.x;
    this.y = x.y;
    this.discription_text = x.discription_text;
    this.link_url = x.link_url;
  }
}
